function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.945 0h-9.89C.893 0 .74.04.603.106l5.374 5.373L7.18 4.322 11.397.106A1.042 1.042 0 0010.945 0zM11.895.603L7.927 4.57l3.967 3.968c.066-.138.106-.29.106-.452V1.055c0-.163-.04-.315-.105-.452zM.106.603C.04.74 0 .893 0 1.055v7.03c0 .163.04.315.106.453L4.073 4.57.106.603z",
  fill: "#0785FE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.43 5.067L6.225 6.225a.35.35 0 01-.497 0L4.571 5.067.603 9.035c.138.066.29.105.452.105h9.89c.163 0 .315-.04.452-.105L7.43 5.067z",
  fill: "#0785FE"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgEmail;